<a [class]="class" class="text-primary" role="button" [routerLink]="url ? [url] : null" [queryParams]="params" target="{{newTab ? '_blank' : '_self'}}" (click)="onLinkClick($event)">
    <i *ngIf="icon" class="{{icon}}"></i>
    <span *ngIf="text" class="{{icon ? 'ps-2' : ''}}">{{text | translate}}</span>
    <ng-content *ngIf="!text && !icon"></ng-content>
</a>